import FilterCollapse from "@/features/sub-families/components/filter-collapse.tsx";
import useSelectedFinishingColoursLabel from "@/features/sub-families/hooks/use-selected-finishing-colours-label.ts";
import { useTranslations } from "@/features/translations/components/translations.tsx";
import FinishingColours from "./internal/finishing-colours.tsx";

const PRODUCT_PROPERTY = "finish" as const;

type Props = {
    idx?: number;
};

export default function FinishingColoursFilter({ idx }: Props) {
    const t = useTranslations();

    const label = useSelectedFinishingColoursLabel();

    return (
        <FilterCollapse
            productProperty={PRODUCT_PROPERTY}
            title={<span>{t("finish")}</span>}
            details={label}
            isDesign
            idx={idx}
        >
            <FinishingColours />
        </FilterCollapse>
    );
}
